import React from 'react';
import {View, StyleSheet, Platform} from 'react-native';
import Styles from 'src/components/Styles';
import RecentOrdersButton from './recentOrder/RecentOrdersButton';
import CustomSearchbar from 'src/components/elements/CustomSearchField';
import SearchIcon from 'src/components/img/svg/SearchIcon';
import {getDescriber} from 'src/components/elements/orderAhead/descriptor/DescriptorType';

const {getMenuListCompnentsFontFamily} = getDescriber();

type SearchContainerProps = {
  onChangeText: (text: string) => void;
  searchValue: string;
  placeholder?: string;
  onPressRecentOrders: () => void;
  showRecentOrdersButton?: boolean;
};

const ProductSearchContainer: React.FC<SearchContainerProps> = ({
  onChangeText,
  searchValue,
  placeholder = 'Search products',
  onPressRecentOrders,
}) => {
  return (
    <>
      <CustomSearchbar
        onChangeText={onChangeText}
        value={searchValue}
        placeholder={placeholder}
        containerStyle={styles.searchbar}
        elevation={1}
        removeShadow={true}
        inputStyle={styles.inputStyle}
        searchIcon={<SearchIcon />}
        testID="qa_SearchProducts_fld"
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm13}
      />

      <View style={styles.buttonView} hitSlop={Styles.HitSlop_8}>
        <RecentOrdersButton onPress={onPressRecentOrders} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  searchbar: {
    borderRadius: 32,
    backgroundColor: 'white',
    height: 51,
    borderWidth: 1,
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    alignItems: 'center',
    flexGrow: 1,
    flexShrink: 1,
    marginRight: Styles.Spacing.m2,
  },
  buttonView: {
    justifyContent: 'center',
    alignItems: 'flex-end',
    flexGrow: 0,
    flexShrink: 0,
  },
  inputStyle: {
    color: Styles.Colors.PayNew.darkHuesBase04,
    fontSize: Styles.Fonts.f7,
    fontFamily: getMenuListCompnentsFontFamily(),
    paddingLeft: Styles.Spacing.m2,
    paddingRight: Styles.Spacing.m2,
  },
});

export default ProductSearchContainer;
